import { Component, type ErrorInfo, type ReactNode } from 'react'
import { AlertTriangle } from 'lucide-react'
import { Button } from './ui/button'

interface Props {
  children: ReactNode
}

interface State {
  error: Error | null
}

// Sin esto, cualquier error de render deja la pantalla en blanco (React
// desmonta todo el árbol) sin ningún rastro visible para el usuario ni para
// diagnosticar — solo queda en la consola del navegador, minificado.
export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('ErrorBoundary capturó un error de render:', error, info.componentStack)
  }

  render() {
    if (this.state.error) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background px-4 text-center">
          <AlertTriangle className="size-10 text-destructive" />
          <div>
            <h1 className="text-lg font-semibold">Algo salió mal</h1>
            <p className="mt-1 max-w-md text-sm text-muted-foreground">{this.state.error.message}</p>
          </div>
          <Button onClick={() => window.location.assign('/')}>Volver al inicio</Button>
        </div>
      )
    }
    return this.props.children
  }
}
